<uis-floating-title-form-field
	title="Address"
	helperText="Enter the location to view all the Autoboys vehicle inspection centres in the area.">
	<input #searchField id="address-input" type="text" placeholder="" />
</uis-floating-title-form-field>
